<div class="modal-header">
  <h4 class="modal-title">Промяна на профилна снимка</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" nzForceRepaint>
  <div class="alert alert-primary">
    За да добавите или редактирате профилната си снимка, натиснете върху изображението и изберете желания файл.
  </div>
  <div class="position-relative">
    <button class="w-100 p-0 btn btn-light"
            (click)="fileInput.click()">
      <div class="profile-image">
        <nz-image
          imageAlt="Профилна снимка"
          [imageUrl]="profileImageUrl ?? environment.apiImageDefaultUserProfileUrl"/>
      </div>
    </button>
    @if (environment.apiImageDefaultUserProfileUrl !== profileImageUrl) {
      <button class="btn btn-light border position-absolute top-0 end-0" (click)="onDeleteImage()">
        <i class="fa-solid fa-x" aria-hidden="true"></i>
      </button>
    }
  </div>
  <input
    #fileInput
    id="images"
    type="file"
    accept="image/*"
    class="d-none"
    (change)="onSelectImage($event)"/>
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loading || !canSubmit"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Запази</span>
  </button>
</div>
